import React from 'react';
import { Button, Alert, Icon } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import Breadcrumbs from '@sp/client/components/Breadcrumbs';
import NavBar from '@sp/client/components/NavBar';

import s from './styles.less';

class PlanDetails extends React.Component {
  static propTypes = {
    match: PropTypes.any,
  };
  state = { plan: false, carName: false, services: [] };
  async componentDidMount() {
    const { id } = this.props.match.params;
    try {
      const req = await fetch(`/provider/plan-details/${id}`);
      this.setState({
        plan: req.plan,
        carName: `${req.car.maker.name} ${req.car.model.name}`,
        carPhoto: req.car.specs.carPhoto,
        services: req.plan.Components,
        car2: req.car2,
      });
    } catch (e) {
      this.setState({ error: (e.error || e).toString() });
    }
  }
  breadcrumbs = [
    { name: 'Home', to: '/' },
    {
      name: 'Manage Service Plans',
      to: '/provider/plans',
      react: true,
    },
    { name: 'Plan Details' },
  ];
  render() {
    return (
      <NavBar withPadding>
        <Breadcrumbs paths={this.breadcrumbs} />
        <div className={s.root}>
          {this.state.error && (
            <Alert message={this.state.error} type="error" />
          )}
          <div className={s.header}>Policy Documents</div>
          <div className={s.table}>
            <div className={s.row}>
              <div>
                <div className={s.itemHeader}>Car</div>
                <div className={s.item}>{this.state.carName}</div>
                <div className={s.itemHeader}>Registration</div>
                <div className={s.item}>{this.state.plan.VRN}</div>
                <div className={s.itemHeader}>Current Mileage</div>
                <div className={s.item}>{this.state.plan.currentMileage}</div>
                <div className={s.img}>
                  {' '}
                  <img src={`http://www2.carwebuk.com${this.state.carPhoto}`} />
                </div>
              </div>
              <div>
                <div>Plan number: {this.state.plan.contractNumber}</div>
                {this.state.services
                  .filter(x => x.carNumber === 1)
                  .map((x, index) => (
                    <div key={index}>
                      <div className={s.service}>{x.type}</div>
                      {x.expectedDate && (
                        <div>
                          Expected date:{' '}
                          {moment(x.expectedDate).format('Do MMMM YYYY')}
                        </div>
                      )}
                      {x.expectedMileage && (
                        <div>Expected mileage: {x.expectedMileage}</div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
            {this.state.plan.VRN2 && (
              <div className={s.row}>
                <div>
                  <div className={s.itemHeader}>Car</div>
                  <div className={s.item}>
                    {this.state.car2.maker.name} {this.state.car2.model.name}
                  </div>
                  <div className={s.itemHeader}>Registration</div>
                  <div className={s.item}>{this.state.plan.VRN2}</div>
                  <div className={s.itemHeader}>Current Mileage</div>
                  <div className={s.item}>
                    {this.state.plan.VRN2CurrentMileage}
                  </div>
                  <div className={s.img}>
                    {' '}
                    <img
                      src={`http://www2.carwebuk.com${
                        this.state.car2.specs.carPhoto
                      }`}
                    />
                  </div>
                </div>
                <div>
                  <div>Plan number: {this.state.plan.contractNumber}</div>
                  {this.state.services
                    .filter(x => x.carNumber === 2)
                    .map((x, index) => (
                      <div key={index}>
                        <div className={s.service}>{x.type}</div>
                        {x.expectedDate && (
                          <div>
                            Expected date:{' '}
                            {moment(x.expectedDate).format('Do MMMM YYYY')}
                          </div>
                        )}
                        {x.expectedMileage && (
                          <div>Expected mileage: {x.expectedMileage}</div>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
          <div className={s.docs}>
            <div>
              <Icon type="file-pdf" /> Garage Plan Document -{' '}
              {this.state.plan.contractNumber}
            </div>
            <div className={s.buttons}>
              <a
                href={`/reports/plan/${this.state.plan.id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button>View document</Button>
              </a>
              &nbsp; &nbsp; &nbsp;
              <a
                href={`/reports/plan/${this.state.plan.id}`}
                download={`${this.state.plan.contractNumber}.pdf`}
              >
                <Button type="primary">Download Document</Button>
              </a>
            </div>
          </div>
          <div className={s.back}>
            <Link to="/provider/plans">
              <Button type="primary">{'‹'} Back to Service Plans</Button>
            </Link>
          </div>
        </div>
      </NavBar>
    );
  }
}

export default withRouter(PlanDetails);
